import React from 'react';

export default function Pagination({ itemCount = 1, pageSize = 10, selectedPage = 1, hideWhenSinglePage = true, onSelectPage, children }) {

    let lastPage = Math.ceil(itemCount / pageSize);
    let itemsInLastPage = itemCount % pageSize;
    let firstItemIndex = (pageSize * selectedPage) - pageSize;
    let lastItemIndex = selectedPage < lastPage ? (pageSize * selectedPage) : firstItemIndex + itemsInLastPage
    let btnQty = Math.min(5, lastPage);
    let middleBtnIndex = Math.ceil(btnQty / 2);
    let pageButtons = [];
    pageButtons = Array.from({ length: Math.min(lastPage, btnQty) }, (cv, i) => {
        let pageOffset = selectedPage - middleBtnIndex;
        if (selectedPage - middleBtnIndex <= 0) { pageOffset = 0; }
        if (selectedPage - middleBtnIndex + btnQty > lastPage) { pageOffset = lastPage - btnQty; }

        let pageNum = i + 1 + pageOffset

        let buttonClick = selectedPage !== pageNum ? () => onSelectPage(pageNum) : undefined;
        let buttonClass = selectedPage === pageNum ? "selected" : undefined;
        let pageButton = (<button key={pageNum} className={buttonClass} onClick={buttonClick}>{pageNum}</button>);
        return pageButton;
    });

    /*really small screen buttons------------*/
    btnQty = Math.min(3, lastPage);
    middleBtnIndex = Math.ceil(btnQty / 2);
    let smallScreenPageButtons = [];
    smallScreenPageButtons = Array.from({ length: Math.min(lastPage, btnQty) }, (cv, i) => {
        let pageOffset = selectedPage - middleBtnIndex;
        if (selectedPage - middleBtnIndex <= 0) { pageOffset = 0; }
        if (selectedPage - middleBtnIndex + btnQty > lastPage) { pageOffset = lastPage - btnQty; }

        let pageNum = i + 1 + pageOffset

        let buttonClick = selectedPage !== pageNum ? () => onSelectPage(pageNum) : undefined;
        let buttonClass = selectedPage === pageNum ? "selected" : "";
        let pageButton = (<button key={pageNum} className={`smallScreen ${buttonClass}`} onClick={buttonClick}>{pageNum}</button>);
        return pageButton;
    });
    /*------------really small screen buttons*/

    let prevButtonClick = onSelectPage && selectedPage > 1 ? () => onSelectPage(selectedPage - 1) : undefined;
    let prevButtonClass = selectedPage === 1 ? "disabled" : "";
    let prevButton = (<button className={`prevNext ${prevButtonClass}`} onClick={prevButtonClick}><i className="icon dhicon-left-open-2" /></button>);

    let nextButtonClick = onSelectPage && selectedPage < lastPage ? () => onSelectPage(selectedPage + 1) : undefined;
    let nextButtonClass = selectedPage === lastPage ? "disabled" : "";
    let nextButton = (<button className={`prevNext ${nextButtonClass}`} onClick={nextButtonClick}><i className="icon dhicon-right-open-2" /></button>);

    let paginationControls = (!hideWhenSinglePage || lastPage > 1) && (<div className="paginationControls flex">{prevButton}{pageButtons}{smallScreenPageButtons}{nextButton}</div>);
    let paginationInfo = (!hideWhenSinglePage|| lastPage > 1) && (<div className="paginationInfo"><span>Page {selectedPage} of {lastPage}</span></div>);

    let contents = (<div className="paginationContainer flex flex-row-reverse justify-between py-1">
        {paginationControls}
        {children}
    </div>);

    return contents;
}